import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    name: 'About',
    to: 'about'
  }, {
    name: 'Courses',
    to: 'courses'
  }, {
    name: 'Services',
    to: 'services'
  }, {
    name: 'Testimonials',
    to: 'testimonials'
  }, {
    name: 'Contact',
    to: 'contact'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md border-b-4 border-green-600" data-id="element-261">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-262">
        <RouterLink to="/" data-id="element-263">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tZ5yUyuDxVcEEDCAXtRrjb/logo_language_magnate.png" alt="Language Magnate Academy" className="h-20 w-auto cursor-pointer" data-id="element-264" />
        </RouterLink>
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-265">
          {navLinks.map(link => <Link key={link.to} to={link.to} smooth={true} duration={800} className="text-slate-700 hover:text-green-600 cursor-pointer transition-colors duration-200 font-medium" data-id="element-266">
              {link.name}
            </Link>)}
          <Link to="contact" smooth={true} duration={800} className="bg-green-600 text-white px-6 py-2 rounded-full hover:bg-green-700 transition-colors duration-200 cursor-pointer" data-id="element-267">
            Enroll Now
          </Link>
        </div>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-slate-800" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-268">
          {isMobileMenuOpen ? <XIcon size={28} data-id="element-269" /> : <MenuIcon size={28} data-id="element-270" />}
        </button>
      </div>
      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white border-t border-slate-200 shadow-lg" data-id="element-271">
          <div className="flex flex-col space-y-4 px-6 py-6" data-id="element-272">
            {navLinks.map(link => <Link key={link.to} to={link.to} smooth={true} duration={800} className="text-slate-700 hover:text-green-600 cursor-pointer transition-colors duration-200" onClick={() => setIsMobileMenuOpen(false)} data-id="element-273">
                {link.name}
              </Link>)}
            <Link to="contact" smooth={true} duration={800} className="bg-green-600 text-white px-6 py-3 rounded-full hover:bg-green-700 transition-colors duration-200 text-center cursor-pointer" onClick={() => setIsMobileMenuOpen(false)} data-id="element-274">
              Enroll Now
            </Link>
          </div>
        </div>}
    </nav>;
}